/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, useMediaQuery } from "@mui/material";
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { Location } from 'history'
import { FC, useCallback, useEffect, useMemo, useState } from "react"
import { useHistory, Prompt } from "react-router-dom";
import { DEFAULT_PROJETO, NOME_CLIENTE_MAX_LENGTH, POTENCIA_MINIMA_ENGENHARIA, PROJETOS_CUSTO_ANUAL_MANUTENCAO_GERADOR_PARAM, TIPO_FATURAMENTO } from "src/components/projetos/constants";
import { FormDados } from "src/components/projetos/FormDados";
import { Verticais } from "src/components/vendas/types";
import { VerticaisManager, paths } from "src/components/vendas/VerticaisManager";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { ContaProvider } from "src/providers/cadastros/ContaProvider";
import { EquipeType } from "src/providers/cadastros/ContaProvider/types";
import { getCidades, getGruposEstrutura, getEstados, getLimitacoesProjetos, getDistribuidoresPorTipoDeConta, getRevendas, distribuidoresPorTipoDeConta$, revendas$, getEstadosServico, getRegioes, regioes$, estadosServico$, getDistribuidores, contaUsuario$, CacheType, verificarSegmentoConta } from "src/store/global.store";
import { formState$ } from "src/store/vendas/projetos/store";
import { debounce } from "lodash";
import { Map } from "./Map";
import { Regiao } from "src/types";
import { ConfiguracaoStore } from "src/framework/store/ConfiguracaoStore";
import { projetoSalvoComSucessoDialog } from "./utils/projetoSalvoComSucessoDialog";
import { ListUtil } from "src/framework/commons/ListUtil";
import { ProjetoTipoType, SegmentoType } from "./types";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { ContaUsuario } from "src/store/global.store.types";
import theme from "src/theme/light";
import { notifierStore } from "src/framework/store/NotifierStore";
import { standAlonePage$ } from "src/framework/store/ApiEvents";
import { safeGeocodeByAddress } from "src/framework/commons/MapsUtil";
import * as Sentry from "@sentry/react";
import { useProjetoPersonalizadoOffgridStore } from "src/store/vendas/projetos/personalizado_offgrid/personalizadoOffgrid.store";

interface GetLatLngFromAddressType {
  cep: string;
  enderecoProposta: string;
  cidadeNome: string;
  estadoId: string;
  numero?: string;
  bairro?: string;
}

interface FormInicialProperties {
  segmento?: SegmentoType;
}

const TITULO_MAX_LENGTH = 100

const manager: VerticaisManager = new VerticaisManager(paths, api, apiNoLoading);
const contasProvider = new ContaProvider();
const store = new ConfiguracaoStore(api, PROJETOS_CUSTO_ANUAL_MANUTENCAO_GERADOR_PARAM)

const initLoad = async () => {
  await Promise.all([
    getEstados(),
    getRegioes(),
    getCidades(),
    getGruposEstrutura(),
    getLimitacoesProjetos(),
    getDistribuidores(),
    getDistribuidoresPorTipoDeConta(),
    getRevendas(),
    getEstadosServico({ force: true })
  ])
}

const ProjetosFormInicial: FC<FormInicialProperties> = ({ segmento }) => {
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$);
  const history = useHistory<{ allowAccess?: boolean; noReset?: boolean; done?: boolean; tipo?: ProjetoTipoType }>();
  const formState = useObservable(formState$);
  const distribuidorsState = useObservable(distribuidoresPorTipoDeConta$);
  const regioes = useObservable(regioes$)
  const revendasState = useObservable(revendas$);
  const estadosServico = useObservable(estadosServico$);
  const standAlone = useObservable(standAlonePage$)

  const [clearedState, setClearedState] = useState<boolean>(false);
  const [checkSegmentoConta, setCheckSegmentoConto] = useState<boolean>(false);
  const [valorManutencaoPadrao, setValorManutencaoPadrao] = useState(0)
  const [errorState, setErrorState] = useState<string[]>([]);
  const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<any>(null);
  const [row, setRow] = useState<any>(() => {
    const output = DEFAULT_PROJETO;
    const queryParams = new URLSearchParams(history.location.search);
    const tipo = queryParams.get('tipo') as ProjetoTipoType
    
    if (tipo) {
      output.tipo = tipo;
    }
    
    if (segmento) {
      output.segmento = segmento;
    }

    return output;
  });
  const [oldFormState] = useState(DEFAULT_PROJETO)

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { reset } = useProjetoPersonalizadoOffgridStore(store => store.actions);
  
  useEffect(()=>{
    const queryParams = new URLSearchParams(history.location.search);
    const tipo = queryParams.get('tipo') || row?.tipo || "dimensionado"  
    setRow((old: any) => ({...old, tipo }))
  },[history.location.search, row?.tipo])

  const personalizadoOff = useMemo(() => {
    return formState?.tipo === 'personalizado' && formState?.segmento?.includes('off');
  }, [formState])

  useEffect(()=>{
    if (personalizadoOff && !clearedState) {
      reset()
      formState$.next(DEFAULT_PROJETO)
      setClearedState(true);
    }
  },[personalizadoOff, clearedState])

  const canNavigate = useCallback((location: Location | null = null)=>{
    const allowedLocations = ['/projetos/.*/novo', 'edicao$', 'clonar$']
    const localLocation = location || history.location

    const loc = localLocation as Location<{ done: boolean }>

    return loc.state?.done || allowedLocations.some(item => {
      return loc?.pathname.match(new RegExp(item))
    })
  },[history.location])

  useEffect(()=>{
    if (standAlone !== undefined && !standAlone) {
      store.list().then(res => {
        const manutencaoPadrao = res?.[0]?.valor || 0
        setValorManutencaoPadrao(Number(manutencaoPadrao))
      })
    }
  },[standAlone])

  useEffect(() => {
    return () => {
      if (!canNavigate()) {
        formState$.next(DEFAULT_PROJETO)
      }
    }
  },[canNavigate, history])

  useEffect(()=>{
    if (formState?.isEdit || formState?.tipo === 'kit') {
      if (history.location.search && history.location.search.includes('reativar')) {
        formState.reativar = true;
        formState.recalcular = true;
      }
      setRow(formState)
      return;
    }
    const noReset = history.location.state?.noReset
    setRow(noReset ? (formState || DEFAULT_PROJETO) : DEFAULT_PROJETO)
  }, [formState, history])

  const init = useCallback(()=>{
    const _distribuidorRevendaUsuario: any = LocalStorage.get("solar.userExtraInfo", true)
    setDistribuidorRevendaUsuario(_distribuidorRevendaUsuario)
  },[])

  useEffect(() => {
    initLoad().then(() => {
      init()
    })
  }, [init]);  
  
  useEffect(()=>{
    if (!checkSegmentoConta && row?.segmento) {
      verificarSegmentoConta({ 
        goBack: true,
        segmento: row?.segmento ||'on', 
        revendaId: row?.revenda_id || row?.revenda?.id || undefined, 
        distribuidorId: row?.distribuidor_id || row?.distribuidor?.id || undefined,
      });
      setCheckSegmentoConto(true);
    }
  },[row?.segmento, row?.revenda_id, row?.distribuidor_id, row?.revenda?.id, row?.distribuidor?.id, checkSegmentoConta]);

  const getLatLngFromAddress = useCallback((payload: GetLatLngFromAddressType) => {
    const { cep, cidadeNome, estadoId, numero, bairro, enderecoProposta } = payload;
    if (!estadoId || !cidadeNome) return;
    const endereco = `${enderecoProposta || ''}, ${numero || ''}, ${bairro || ''}, ${cidadeNome}, ${estadoId}, ${cep || ''}`
    safeGeocodeByAddress(endereco)
    .then(res => getLatLng(res[0])).then(({lat, lng}) => {
      setRow((old: typeof row) => ({...old, latitude: lat, longitude: lng}))
    }).catch(err => {
      setRow((old: typeof row) => ({...old, latitude: null, longitude: null}))
      notifierStore.setNotifier({
          title: "Aviso",
          content: "Não foi possível obter a localização a partir do endereço fornecido.",
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true);
    })
  },[])

  const getLatLngFromAddressDebounced = useCallback(
    debounce((payload: GetLatLngFromAddressType) => {
      getLatLngFromAddress(payload)
    }, 800),
    []
  );
  
  useEffect(()=>{
    getLatLngFromAddressDebounced({
      cep: row.cep,
      cidadeNome: row.cidade?.nome,
      estadoId: row.estado?.id,
      numero: row.numero,
      enderecoProposta: row.endereco_proposta,
      bairro: row.bairro,
    })
  },[row.tipo, getLatLngFromAddressDebounced, row.endereco_proposta, row.cep, row.cidade, row.estado, row.numero, row.bairro])

  const onClickNext = useCallback((state: any)=>{
    formState$.next({...formState$.getValue(), ...state})

    const urlsFromTipo: {[index: string]: string} = {
      vertical: '/projetos/verticais/novo',
      personalizado: '/projetos/personalizados/novo',
      dimensionado: '/projetos/dimensionados/novo',
      kit: '/projetos/kits/novo'
    }
    
    const urlsFromTipoEdicao: {[index: string]: string} = {
      vertical: `/projetos/${state.id}/verticais/edicao`,
      personalizado: `/projetos/${state.id}/personalizados/edicao`,
      dimensionado: `/projetos/${state.id}/dimensionados/edicao`,
      kit: `/projetos/${state.id}/kits/edicao`
    }

    const urlsFromTipoClonar: {[index: string]: string} = {
      personalizado: `/projetos/${state.id}/personalizados/clonar`,
      dimensionado: `/projetos/${state.id}/dimensionados/clonar`,
    }

    if (urlsFromTipo[state.tipo]) {
      if (state.clonar_projeto) {
        history.push(urlsFromTipoClonar[state.tipo], { allowAccess: true })
        return
      }
      
      if (state.isEdit) {
        history.push(urlsFromTipoEdicao[state.tipo], { allowAccess: true })
        return
      }
      history.push(urlsFromTipo[state.tipo], { allowAccess: true })
    }
  },[history])

  const afterSave = useCallback((response: IDataResponse) => {
    projetoSalvoComSucessoDialog(response?.data?.[0]?.codigo_venda, history, {
      onConfirmation: () => setRow(DEFAULT_PROJETO),
      tipoProjeto: row?.tipo,
    })
  }, [history, row?.tipo])

  const validate = useCallback(() => {
    const _errorState = [...errorState]
    const messages: string[] = [];

    const data: Verticais = {...row}

    if (!data?.cliente_proposta){
      messages.push("O campo nome do cliente é obrigatório");
      _errorState.push("cliente_proposta")
    }

    if (data.cliente_proposta && data.cliente_proposta.length > NOME_CLIENTE_MAX_LENGTH) {
      messages.push(`O campo nome do cliente deve ter no máximo ${NOME_CLIENTE_MAX_LENGTH} caracteres`);
      _errorState.push("cliente_proposta")
    }


    if (data?.titulo && data?.titulo?.length > TITULO_MAX_LENGTH) {
      messages.push("O campo título deve ter no máximo 100 caracteres");
      _errorState.push("titulo")
    }

    if (!data?.cidade) {
      messages.push("O campo cidade é obrigatório");
      _errorState.push("cidade_id")
    }

    if (!data?.distribuidor_id && !data?.distribuidor?.id) {
        messages.push("O campo distribuidor é obrigatório");
        _errorState.push("distribuidor_id")
    }



    if(data?.email_proposta){
      if (!ValidateUtil.isValidEmail(data?.email_proposta)) {
        messages.push("E-mail inválido");
        _errorState.push("email_proposta")
      }else{
        ListUtil.removeItem(_errorState, "email_proposta")
      }
    }else{
      ListUtil.removeItem(_errorState, "email_proposta")
    }

    if (messages.length > 0) {
      setErrorState(_errorState)
      notifierStore.setNotifier({
          title: "Aviso",
          content: messages,
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true)
    }

    return messages.length === 0;
  }, [errorState, row])

  const mostrarOpcaoServico = useMemo(()=>{
    if (!row?.estado?.id) return true;
    const reg = regioes?.data || []
    const estadosPermitemServico: string[] = (estadosServico?.data || []).map((item: any) => item.regiao_id)
    const currentRegioes: string[] = reg.filter((item: Regiao) => {
      if (!item.estados || item.estados.length === 0) return false;
      const ids = item.estados.map((estado: any) => estado.estado_id)
      return ids.includes(row.estado.id)
    }).map((item: any) => item.id)
    return estadosPermitemServico.some(item => {
      if (currentRegioes.includes(item)) return true;
      return false;
    })
  },[regioes, row?.estado, estadosServico])

  const showMap = useMemo(()=>{
    if (isMobile) return false;
    if (!row.latitude) return false;
    if (!row.longitude) return false;
    if (!row.endereco_proposta) return false;
    if (!row.cidade) return false;
    if (!row.estado) return false;
    return true;
  },[row.cidade, row.endereco_proposta, row.estado, row.latitude, row.longitude])
 
  const captureData = useCallback(async(data: any) => {
    if (!validate()) return

    const state = { ...data };

    const distribuidores = distribuidoresPorTipoDeConta$.getValue();

    if (state?.distribuidor === undefined) {
      const idxDistribuidor = distribuidores.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.distribuidor_id)
      if (idxDistribuidor > -1) {
        state.distribuidor = distribuidores.data[idxDistribuidor]
      }
    }

    if (state?.revenda === undefined) {
      const idxRevenda = revendasState?.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.revenda_id)
      
      if (idxRevenda > -1) {
        state.revenda = revendasState.data[idxRevenda]
      } else {
        if (distribuidorRevendaUsuario?.revenda_id && distribuidorRevendaUsuario?.revenda_nome && distribuidorRevendaUsuario?.revenda_cnpj_cpf) {
          state.revenda = {
            id: distribuidorRevendaUsuario.revenda_id,
            nome: distribuidorRevendaUsuario.revenda_nome,
            cnpj_cpf: distribuidorRevendaUsuario.revenda_cnpj_cpf,
          }
        }
      }
    }

    const cpfCnpjDistribuidor = state?.distribuidor?.cnpj_cpf;

    if (!state?.codigo_venda) {
      if (cpfCnpjDistribuidor === "" || cpfCnpjDistribuidor === undefined || cpfCnpjDistribuidor === null) {
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: "Distribuidor não informado ou CNPJ inválido!",
            timeOut: 3000,
            onClose: () => {
                notifierStore.setOpen(false);
            }
        })
        notifierStore.setOpen(true);
        return;
      }
    }

    const hasRevenda = !!state?.revenda;

    if ((oldFormState?.distribuidor?.id !== state?.distribuidor?.id) || (oldFormState?.distribuidor?.id === state?.distribuidor?.id && hasRevenda && oldFormState?.revenda?.id !== state?.revenda?.id)) {
      let codigoDistribuidorRevenda = state?.distribuidor?.id;
      
      if (hasRevenda) {
          codigoDistribuidorRevenda = state?.revenda?.id;
      }

      const responseEquipe: EquipeType | null = await contasProvider.getEquipe(codigoDistribuidorRevenda, state.segmento);

      state.ev_id = responseEquipe?.ev_id;
      state.supervisor_id = responseEquipe?.supervisor_id;
      state.assistente_id = responseEquipe?.assistente_id;
    }
    
    state.distribuidor_id = state?.distribuidor?.id;
    state.cidade_id = state?.cidade?.id;
    state.estado_id = state?.estado?.id;
    
    return state;
  },[distribuidorRevendaUsuario, revendasState, oldFormState?.distribuidor?.id, oldFormState?.revenda?.id, validate])

  const onSave = useCallback(async(data: any, callback: any = null) => {
    const state = await captureData(data)

    if (!state) {
      Sentry.captureMessage("onSave - captureData, state vazio", {
        level: "warning",
        extra: { data, state }
      });

      notifierStore.setNotifier({
          title: "Atenção!!!",
          content: "Não foi possível salvar o projeto, verifique os campos preenchidos!",
          timeOut: 3000,
          onClose: () => {
              notifierStore.setOpen(false);
          }
      })
      notifierStore.setOpen(true);

      return;
    }
    
    if (state?.id === 0) {
      delete state.id
    }

    delete state?.limitacao_projeto;
    delete state.ev
    delete state.distribuidor
    delete state.revenda
    delete state.analista
    delete state.cidade
    delete state.revisoes

    const payload = {
      id: state?.id,
      titulo: state.titulo,
      assistente_id: state.assistente_id,
      supervisor_id: state.supervisor_id,
      auto_comissao: state.auto_comissao,
      cidade_id: state.cidade_id,
      cliente_proposta: state.cliente_proposta,
      codigo_venda: state.codigo_venda,
      cpf_cnpj_proposta: state.cpf_cnpj_proposta ? state.cpf_cnpj_proposta.replace(/[^a-zA-Z0-9]/g,'') : '',
      distribuidor_id: state.distribuidor_id,
      email_proposta: state.email_proposta,
      endereco_proposta: state.endereco_proposta,
      estado_id: state.estado_id,
      ev_id: state.ev_id,
      latitude: state.latitude,
      longitude: state.longitude,
      nota_fiscal_triangular: state.nota_fiscal_triangular,
      observacao: state.observacao,
      prioridade: state.prioridade,
      revenda_id: state.revenda_id,
      segmento: state.segmento,
      setor: state.setor,
      situacao: state.situacao,
      telefone_proposta: state.telefone_proposta,
      tipo: state.tipo,
      engenharia: (state.tipo?.includes('vertical') || Number(state?.potencia) > POTENCIA_MINIMA_ENGENHARIA),
      tipo_faturamento: TIPO_FATURAMENTO[0].value,
      endereco: {
        cep: state.cep?.replace(/\D/g, ""),
        logradouro: state.endereco_proposta,
        bairro: state.bairro,
        numero: state.numero,
        cidade_id: state.cidade_id,
        estado_id: state.estado_id
      }
    }

    if (!payload.revenda_id) {
      Object.assign(payload, {
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
      })
    }

    manager.save({
      row: payload,
      primaryKey: payload?.id
    }).then((response: IDataResponse) => {
      if ([STATUS_CODE.OK, STATUS_CODE.CREATED].includes(response.statusCode)) {
        if (typeof callback === 'function') callback(response)
      }
    })
   }, [captureData])

  useEffect(() => {
    const permissions = PermissionUtil.getPermissions();
    if (!formState?.isEdit && PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VISUALIZAR_FILIAIS, permissions) && !PermissionUtil.isAdministrador(permissions) && contaUsuario?.data?.filiais?.length && contaUsuario?.data?.distribuidor?.id) {
      setRow((old: any) => ({...old, distribuidor_id: contaUsuario?.data?.distribuidor?.id, distribuidor: contaUsuario?.data?.distribuidor }))
    }
  },[contaUsuario?.data?.distribuidor, contaUsuario?.data?.filiais?.length, formState?.isEdit])

  useEffect(() => {
    if (distribuidorRevendaUsuario && !row?.distribuidor?.id) {
          if (!distribuidorRevendaUsuario.isIntelbras) {
            row.distribuidor_id = distribuidorRevendaUsuario?.distribuidor_id;

              const distribuidores = distribuidorsState.data;
              const distribuidorIdx = distribuidores.findIndex((d: any) => d.id === row.distribuidor_id)
              if (distribuidorIdx > -1) {
                row.distribuidor = distribuidores[distribuidorIdx];
              }

              if (distribuidorRevendaUsuario?.revenda_id) {
                  row.revenda_id = distribuidorRevendaUsuario?.revenda_id;
                  const revendas = revendas$.getValue().data;
                  const revendaIdx = revendas.findIndex((r) => r.id === row.revenda_id)
                  if (revendaIdx > -1) {
                    row.revenda = revendas[revendaIdx];
                  }
              }

              if (standAlone) {
                row.segmento = 'vertical_ongrid'
                row.tipo = 'vertical'
              }

              setRow(row)
              verificarSegmentoConta({ 
                goBack: true,
                segmento: row?.segmento ||'on', 
                revendaId: row?.revenda_id || row?.revenda?.id || undefined, 
                distribuidorId: row?.distribuidor_id || row?.distribuidor?.id || undefined,
              });
          }
      }

  }, [row, distribuidorRevendaUsuario, distribuidorsState, revendasState]);

  return (
      <>
      <Paper elevation={0}>
        <FormDados
          onSaveAndClose={data => onSave(data, afterSave)}
          formState={row}
          onChangeValue={(newState: any) => setRow({ ...newState })}
          errorState={errorState}
          onChangeError={(newErrorState: any) => setErrorState(newErrorState)}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onClickNext={async() => {
            const result = await captureData(row)
            if (!result) return;
            const state = { ...result } 
              if (state?.estado?.id) {
                const currentRegioes = regioes.data.filter((regiao: any) => {
                  const estadosList = regiao.estados || []


                  const estados = estadosList.map((item: any) => item.estado_id)
                  return estados.includes(state?.estado?.id)
                })
                state.regioes = currentRegioes
              }

              state.codigo_venda = result.codigo_venda
              state.recebe_servico = mostrarOpcaoServico
              state.latitude = row.latitude
              state.longitude = row.longitude

              const validar = !state.isEdit || !state?.valor || !state?.componentes?.length;
              if (validar && Number(state.valor_anual_manutencao || 0) === 0 && valorManutencaoPadrao > 0) {
                state.valor_anual_manutencao = valorManutencaoPadrao
              }

              setRow(state)
              onClickNext(state)
          }}
        />

      {showMap && (
          <Box px={2}>
            <Map location={{ latitude: row.latitude, longitude: row.longitude }}  />
          </Box>
        )}
      </Paper>
      <Prompt when={!!formState?.codigo_venda} message={(location) => {
        if (canNavigate(location)) return true;
        return `Deseja cancelar a ${formState?.isEdit ? 'edição' : 'criação'} do projeto?`
      }}/>
    </>
  )    
}

export { ProjetosFormInicial }